// extracted by mini-css-extract-plugin
export var price = "plan-module--price--2OWTJ";
export var price__anchor = "plan-module--price__anchor--_nkeU";
export var price__more_btn = "plan-module--price__more_btn--1hScA";
export var content = "plan-module--content--eenPc";